import React, { useState, useEffect } from "react";
import { API_BASE, authHeaders } from "./AgencyContext";

const G = "#0077B5";
const STATUS_BADGE = {
  active: { bg: "#E1F5EE", color: "#0F6E56" },
  onboarding: { bg: "#E6F1FB", color: "#0C447C" },
  invited: { bg: "#f3f2ef", color: "#666" },
  paused: { bg: "#FAEEDA", color: "#633806" },
  churned: { bg: "#FAE4E4", color: "#8B1A1A" },
};

export default function AgencyClientList() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [sort] = useState("created_at");

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({ sort });
    if (filter !== "all") params.set("status", filter);
    fetch(`${API_BASE}/app/api/agency/clients?${params}`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : { clients: [] })
      .then(d => { setClients(d.clients || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [filter, sort]);

  const exportCsv = () => {
    const header = "Name,Email,Plan,Status,Onboarded\n";
    const rows = clients.map(c =>
      `"${c.client_name}","${c.client_email}","${c.plan}","${c.status}","${c.onboarded_at || ''}"`
    ).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "agency-clients.csv";
    a.click();
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div style={{ fontSize: 22, fontWeight: 500 }}>Clients</div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={exportCsv} style={{ background: "transparent", color: G, border: "1px solid " + G, borderRadius: 6, padding: "8px 14px", fontSize: 12, cursor: "pointer" }}>Export CSV</button>
          <a href="#/agency/invite" style={{ background: G, color: "#fff", border: "none", borderRadius: 6, padding: "8px 16px", fontSize: 12, fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center" }}>+ Add client</a>
        </div>
      </div>

      {/* Filters */}
      <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
        {["all", "active", "onboarding", "invited", "paused", "churned"].map(f => (
          <button key={f} onClick={() => setFilter(f)} style={{
            background: filter === f ? G : "#fff", color: filter === f ? "#fff" : "#666",
            border: "1px solid " + (filter === f ? G : "rgba(0,0,0,0.1)"),
            borderRadius: 6, padding: "6px 12px", fontSize: 12, cursor: "pointer", textTransform: "capitalize",
          }}>{f} {f === "all" ? `(${clients.length})` : ""}</button>
        ))}
      </div>

      {loading ? (
        <div style={{ padding: 20, textAlign: "center", color: "#888" }}>Loading…</div>
      ) : (
        <div style={{ background: "#fff", border: "0.5px solid rgba(0,0,0,0.1)", borderRadius: 12, overflow: "hidden" }}>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 80px", gap: 0, padding: "10px 16px", background: "#f3f2ef", borderBottom: "0.5px solid rgba(0,0,0,0.1)" }}>
            {["CLIENT", "PLAN", "STATUS", ""].map(h => (
              <div key={h} style={{ fontSize: 10, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: 0.5 }}>{h}</div>
            ))}
          </div>
          {clients.map((c, i) => {
            const st = STATUS_BADGE[c.status] || STATUS_BADGE.invited;
            return (
              <div key={c.id} style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 80px", gap: 0, padding: "12px 16px", borderBottom: i < clients.length - 1 ? "0.5px solid rgba(0,0,0,0.05)" : "none", alignItems: "center" }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500 }}>{c.client_name}</div>
                  <div style={{ fontSize: 11, color: "#888" }}>{c.client_email}</div>
                </div>
                <div style={{ fontSize: 12 }}>{c.plan}</div>
                <div><span style={{ fontSize: 11, background: st.bg, color: st.color, padding: "2px 8px", borderRadius: 12, fontWeight: 600 }}>{c.status}</span></div>
                <div><a href={`#/agency/clients/${c.id}`} style={{ fontSize: 12, color: G, textDecoration: "none" }}>View</a></div>
              </div>
            );
          })}
          {clients.length === 0 && (
            <div style={{ padding: 20, textAlign: "center", fontSize: 13, color: "#888" }}>No clients match this filter.</div>
          )}
          {/* Dashed add row */}
          <a href="#/agency/invite" style={{ display: "block", padding: "14px 16px", borderTop: "2px dashed rgba(0,0,0,0.1)", textAlign: "center", fontSize: 13, color: G, textDecoration: "none" }}>
            + Add another client
          </a>
        </div>
      )}
    </div>
  );
}
